module.exports = __webpack_public_path__ + "img/pre_rodiny_mladych_seniorov.6074afdf.svg";